/**
 * IE Specific fixes and features
 *
 * 
 * @class rlIESpecific
 * @memberOf jQuery.fn
 */

(function ($) {
    $.fn.rlIeSpecific = function () {
        
        //Check if user agent is IE
        function GetIE() {
            var sAgent = window.navigator.userAgent;
            var Idx = sAgent.indexOf("MSIE");

            if (Idx > 0) { return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx))); }
            else if (!!navigator.userAgent.match(/Trident\/7\./)) { return 11; }
            else { return 0; }
        }
        //is IE11
        if (GetIE() == 11) {
            $('html').addClass('ie11');
           
        }
        //is IE10
        if (GetIE() == 10) {
            $('html').addClass('ie10');   
        }
        //is EDGE (early versions report as EDGE / 'chrome' versions report as EDG)
        if (/Edge/.test(navigator.userAgent)) { 
           $('html').addClass('edge');
        }


        //Things that effect both IE 10 & 11
        if (GetIE() == 11 || GetIE() == 10) {
            //Match height to combat IE's lack of min-height support. 
            //Use the match-height-ie class where nessaccery and overwrite css to height auto on element (use IE class thats on html tag).
            $('.match-height-ie').matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false
            });
        }

        //Defect fix for bug 196038 #####################
        if (window.location !== window.parent.location) {
            $('.royal-neutral, .royal-purple').addClass('no-before-after');
        }

    }
}(jQuery));
